// store.js
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import { combineReducers } from "redux";
// import cityReducer from "./reducers/cityReducer_";
// import heritageReducer from "./reducers/heritageReducer_";
// import heritageBookingReducer from "./reducers/heritageBookingReducer_";
// import bookingFormReducer from "./reducers/bookingFormReducer";
// import paymentReducer from "./reducers/paymentReducer_";
// import { initializePaymentReducer } from "./reducers/initializePaymentReducer_";
// import checksumReducer from "./reducers/checksumReducer_";
import { RESET_STORE } from "./types/cityTypes";
import culturalHeritageReducer from "./reducers/culturalHeritageReducer";
import kmcReducer from "./reducers/kmcReducer";
import msedclReducer from "./reducers/msedclReducer";
import mpczReducer from "./reducers/mpczReducer";
import merchantReducer from "./reducers/merchantReducer";

const appReducer = combineReducers({
  culturalHeritageReducer: culturalHeritageReducer,
  kmcReducer,
  msedclReducer,
  mpczReducer,
  merchantReducer,
  // heritage: heritageReducer,
  // heritageBooking: heritageBookingReducer,
  //formBooking: bookingFormReducer,
  // payment: paymentReducer,
  // initializePayment: initializePaymentReducer,
  // checksum: checksumReducer,
});
const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined; // 👈 clears the whole state
  }
  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
